<header *ngIf="!canAccess" [ngClass]="{ 'mnc-header': isIos }" class=" bg-body navbar-sticky sticky-top z-fixed px-0 is-stuck" data-sticky-element>
  <app-enviroment-state></app-enviroment-state>
  <div class="navbar navbar-expand-lg px-0">
    <div class="container">
      <!-- Mobile offcanvas menu toggler (Hamburger) -->
      <button *ngIf="this.privateMode" type="button" class="navbar-toggler me-3 me-lg-0" (click)="openNavbar()"
        aria-controls="navbarNav" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar brand (Logo) -->
      <a class="navbar-brand py-1 py-md-2 py-xl-2 me-2 me-sm-n4 me-md-n5 me-lg-0" [routerLink]="['/']">
        <!-- [src]="logoHeader || 'assets/placeholder.png'" Un logo estático para evitar el parpadeo -->
        <img class="d-block" [src]="this.logoHeader || this.configService.companyConfig.logo.base" width="170"
          alt="Málaga no caduca" />
      </a>

      <!-- Navegación principal que se convierte en offcamvas en pantallas <992 px de ancho (lg breakpoint) -->
      <nav *ngIf="this.privateMode" class="offcanvas offcanvas-start safe-area" id="navbarNav" tabindex="-1"
        aria-labelledby="navbarNavLabel">
        <div class="offcanvas-header py-3">
          <h5 class="offcanvas-title" id="navbarNavLabel">
            <img class="d-block" src="{{ this.logoOffCanvas }}" width="125" alt="Málaga no caduca" />
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
            <i class="bi bi-x-circle-fill h1 text-primary"></i>
          </button>
        </div>
        <div class="offcanvas-body pt-2 pb-4 py-lg-0 mx-lg-auto">
          <ul class="navbar-nav position-relative">
            <li class="nav-item dropdown py-lg-2 me-lg-n1 me-xl-0">
              <a class="nav-link cursor-pointer" aria-current="page" role="button" aria-expanded="false"
                [class.active]="isActive('/auth-home')" data-bs-dismiss="offcanvas" (click)="changeTab('auth-home')"
                (keydown.enter)="changeTab('auth-home')" (keydown.space)="changeTab('auth-home')" tabindex="0"><i
                  class="bi bi-house me-2 d-flex d-md-none"></i>{{ "eess.shared.header.home" | translate }}</a>
            </li>
            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0">
              <a class="nav-link cursor-pointer" [class.active]="isActive('/profile')" data-bs-dismiss="offcanvas"
                (click)="changeTab('/profile')" (keydown.enter)="changeTab('/profile')"
                (keydown.space)="changeTab('/profile')" tabindex="0"><i
                  class="bi bi-person-vcard me-2 d-flex d-md-none"></i>{{ "eess.shared.header.myData" | translate }}</a>
            </li>
            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0">
              <a class="nav-link cursor-pointer" [class.active]="isActive('/delivery-list')" data-bs-dismiss="offcanvas"
                (click)="changeTab('/delivery-list')" (keydown.enter)="changeTab('/delivery-list')"
                (keydown.space)="changeTab('/delivery-list')" tabindex="0"><i
                  class="bi bi-person-vcard me-2 d-flex d-md-none"></i>{{ "eess.shared.header.deliveryList" | translate }}</a>
            </li>
            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0">
              <a class="nav-link cursor-pointer" [class.active]="isActive('/beneficiaries')" data-bs-dismiss="offcanvas"
                (click)="changeTab('/beneficiaries')" (keydown.enter)="changeTab('/beneficiaries')"
                (keydown.space)="changeTab('/beneficiaries')" tabindex="0"><i
                  class="bi bi-people-fill me-2 d-flex d-md-none"></i>Listado de Beneficiarios</a>
            </li>
            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0">
              <a class="nav-link cursor-pointer" [class.active]="isActive(['/help', '/contact'])"
                data-bs-dismiss="offcanvas" (click)="changeTab('/help')" (keydown.enter)="changeTab('/help')"
                (keydown.space)="changeTab('/help')" tabindex="0"><i
                  class="bi bi-question-circle me-2 d-flex d-md-none"></i>{{ "eess.shared.header.help" | translate
                }}</a>
            </li>
          </ul>
        </div>
      </nav>

      <!-- Button group pública -->
      <div *ngIf="!this.privateMode" class="d-flex gap-sm-1">
        <!-- Acceder a MNC -->
        <a class="btn btn-primary animate-shake me-2 rounded-circle rounded-lg-2 p-2 p-lg-btn" (click)="logIn()"
          (keydown.enter)="logIn()" (keydown.space)="logIn()" tabindex="0">
          <i class="bi bi-person-plus fs-lg animate-target ms-lg-n2 me-lg-1 p-015 p-lg-0"></i>
          <span class="d-none d-xl-inline ms-1">{{
            "eess.shared.header.imAEESS" | translate
            }}</span>
        </a>

        <!-- AYUDA  -->
        <a class="btn bg-secondary animate-scale text-white rounded-circle rounded-lg-2 p-2 p-lg-btn"
          [routerLink]="['/help']">
          <i class="bi bi-question-circle fs-lg animate-target ms-lg-n2 me-lg-1 p-015 p-lg-0"></i>
          <span class="d-none d-xl-inline ms-1">{{
            "eess.shared.header.help" | translate
            }}</span>
        </a>
      </div>

      <div *ngIf="this.privateMode" class="d-flex gap-sm-1">
        <!-- SALIR / DESCONECTAR  -->
        <a class="btn btn-icon animate-shake position-relative bg-primary rounded-circle overflow-hidden d-flex align-items-center ms-2"
          role="button" aria-expanded="false" aria-label="Salir" (click)="this.logOut()" (keydown.enter)="this.logOut()"
          (keydown.space)="this.logOut()" tabindex="0">
          <i class="bi bi-box-arrow-left h6 pb-0 mb-0 text-white fw-normal"></i>
        </a>
      </div>
    </div>
  </div>
</header>